import { render } from "./Tab.vue?vue&type=template&id=00f5a57c"
import script from "./Tab.vue?vue&type=script&lang=js"
export * from "./Tab.vue?vue&type=script&lang=js"
script.render = render

export default script